import {
    useState,
    forwardRef,
    useImperativeHandle,
    useContext,
} from 'react'

import ExpandableComponentContext from "../../Contexts/ExpandableComponentContext"

const countryOptions = [
    { label: 'United States', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Afghanistan', code: '93', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Albania', code: '355', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Algeria', code: '213', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Andorra', code: '376', nsnLength: { min: 6, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Angola', code: '244', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Antigua and Barbuda', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Argentina', code: '54', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Armenia', code: '374', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Australia', code: '61', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Austria', code: '43', nsnLength: { min: 4, max: 13 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Azerbaijan', code: '994', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bahamas', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bahrain', code: '973', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bangladesh', code: '880', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Barbados', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Belarus', code: '375', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Belgium', code: '32', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Belize', code: '501', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Benin', code: '229', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bhutan', code: '975', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bolivia', code: '591', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bosnia and Herzegovina', code: '387', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Botswana', code: '267', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Brazil', code: '55', nsnLength: { min: 10, max: 11 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Brunei', code: '673', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Bulgaria', code: '359', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Burkina Faso', code: '226', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Burundi', code: '257', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Cambodia', code: '855', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Cameroon', code: '237', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Canada', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Cape Verde', code: '238', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Central African Republic', code: '236', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Chad', code: '235', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Chile', code: '56', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'China', code: '86', nsnLength: { min: 11, max: 11 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Colombia', code: '57', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Comoros', code: '269', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Congo (Democratic Republic)', code: '243', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Congo (Republic)', code: '242', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Costa Rica', code: '506', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Croatia', code: '385', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Cuba', code: '53', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Cyprus', code: '357', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Czech Republic', code: '420', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Denmark', code: '45', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Djibouti', code: '253', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Dominica', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Dominican Republic', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ecuador', code: '593', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Egypt', code: '20', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'El Salvador', code: '503', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Equatorial Guinea', code: '240', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Eritrea', code: '291', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Estonia', code: '372', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Eswatini', code: '268', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ethiopia', code: '251', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Fiji', code: '679', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Finland', code: '358', nsnLength: { min: 5, max: 12 }, extensionLength: { min: 1, max: 5 } },
    { label: 'France', code: '33', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Gabon', code: '241', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Gambia', code: '220', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Georgia', code: '995', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Germany', code: '49', nsnLength: { min: 7, max: 11 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ghana', code: '233', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Greece', code: '30', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Grenada', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Guatemala', code: '502', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Guinea', code: '224', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Guinea-Bissau', code: '245', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Guyana', code: '592', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Haiti', code: '509', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Honduras', code: '504', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Hong Kong', code: '852', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Hungary', code: '36', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Iceland', code: '354', nsnLength: { min: 7, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'India', code: '91', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 6 } },
    { label: 'Indonesia', code: '62', nsnLength: { min: 7, max: 12 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Iran', code: '98', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Iraq', code: '964', nsnLength: { min: 8, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ireland', code: '353', nsnLength: { min: 7, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Israel', code: '972', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Italy', code: '39', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ivory Coast', code: '225', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Jamaica', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Japan', code: '81', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Jordan', code: '962', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kazakhstan', code: '7', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kenya', code: '254', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kiribati', code: '686', nsnLength: { min: 5, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kosovo', code: '383', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kuwait', code: '965', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Kyrgyzstan', code: '996', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Laos', code: '856', nsnLength: { min: 8, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Latvia', code: '371', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Lebanon', code: '961', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Lesotho', code: '266', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Liberia', code: '231', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Libya', code: '218', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Liechtenstein', code: '423', nsnLength: { min: 7, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Lithuania', code: '370', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Luxembourg', code: '352', nsnLength: { min: 4, max: 11 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Macau', code: '853', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Madagascar', code: '261', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Malawi', code: '265', nsnLength: { min: 7, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Malaysia', code: '60', nsnLength: { min: 7, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Maldives', code: '960', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mali', code: '223', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Malta', code: '356', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Marshall Islands', code: '692', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mauritania', code: '222', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mauritius', code: '230', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mexico', code: '52', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 6 } },
    { label: 'Micronesia', code: '691', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Moldova', code: '373', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Monaco', code: '377', nsnLength: { min: 5, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mongolia', code: '976', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Montenegro', code: '382', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Morocco', code: '212', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Mozambique', code: '258', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Myanmar', code: '95', nsnLength: { min: 7, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Namibia', code: '264', nsnLength: { min: 7, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Nauru', code: '674', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Nepal', code: '977', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Netherlands', code: '31', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'New Zealand', code: '64', nsnLength: { min: 8, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Nicaragua', code: '505', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Niger', code: '227', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Nigeria', code: '234', nsnLength: { min: 7, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'North Korea', code: '850', nsnLength: { min: 4, max: 13 }, extensionLength: { min: 1, max: 5 } },
    { label: 'North Macedonia', code: '389', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Norway', code: '47', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Oman', code: '968', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Pakistan', code: '92', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Palau', code: '680', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Palestine', code: '970', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Panama', code: '507', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Papua New Guinea', code: '675', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Paraguay', code: '595', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Peru', code: '51', nsnLength: { min: 8, max: 11 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Philippines', code: '63', nsnLength: { min: 8, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Poland', code: '48', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Portugal', code: '351', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Qatar', code: '974', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Romania', code: '40', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Russia', code: '7', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Rwanda', code: '250', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Saint Kitts and Nevis', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Saint Lucia', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Saint Vincent and the Grenadines', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Samoa', code: '685', nsnLength: { min: 5, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'San Marino', code: '378', nsnLength: { min: 6, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Saudi Arabia', code: '966', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Senegal', code: '221', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Serbia', code: '381', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Seychelles', code: '248', nsnLength: { min: 7, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Sierra Leone', code: '232', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Singapore', code: '65', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Slovakia', code: '421', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Slovenia', code: '386', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Solomon Islands', code: '677', nsnLength: { min: 5, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Somalia', code: '252', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'South Africa', code: '27', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'South Korea', code: '82', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'South Sudan', code: '211', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Spain', code: '34', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Sri Lanka', code: '94', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Sudan', code: '249', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Suriname', code: '597', nsnLength: { min: 6, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Sweden', code: '46', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Switzerland', code: '41', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Syria', code: '963', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Taiwan', code: '886', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Tajikistan', code: '992', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Tanzania', code: '255', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Thailand', code: '66', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Timor-Leste', code: '670', nsnLength: { min: 7, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Togo', code: '228', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Tonga', code: '676', nsnLength: { min: 5, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Trinidad and Tobago', code: '1', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Tunisia', code: '216', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Turkey', code: '90', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Turkmenistan', code: '993', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Tuvalu', code: '688', nsnLength: { min: 5, max: 6 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Uganda', code: '256', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Ukraine', code: '380', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'United Arab Emirates', code: '971', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'United Kingdom', code: '44', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Uruguay', code: '598', nsnLength: { min: 8, max: 8 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Uzbekistan', code: '998', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Vanuatu', code: '678', nsnLength: { min: 5, max: 7 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Vatican City', code: '379', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Venezuela', code: '58', nsnLength: { min: 10, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Vietnam', code: '84', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Yemen', code: '967', nsnLength: { min: 8, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Zambia', code: '260', nsnLength: { min: 9, max: 9 }, extensionLength: { min: 1, max: 5 } },
    { label: 'Zimbabwe', code: '263', nsnLength: { min: 9, max: 10 }, extensionLength: { min: 1, max: 5 } },
];

export default forwardRef(({ data, readOnly = false, isMandatory = true, title }, ref) => {

    const ExpandableComponentData = useContext(ExpandableComponentContext)

    const isInteracted = ExpandableComponentData ? ExpandableComponentData?.isInteracted : false

    // ✅ Determine initial country without mutating `data`
    let initialCountry = countryOptions[0]
    if (data?.countryCode) {
        const match = countryOptions.find(option => String(option.code) === String(data.countryCode))
        if (match) {
            initialCountry = match
        }
    }

    const phoneNumberData = {
        countryCode: initialCountry,
        number: data?.number || '',
        extension: data?.extension || '',
    }

    const [selectedCountry, setSelectedCountry] = useState(phoneNumberData.countryCode)
    const [phone, setPhone] = useState(phoneNumberData.number)
    const [extension, setExtension] = useState(phoneNumberData.extension)
    const [error, setError] = useState(false)

    const formatPhone = (value) => {
        if (!value) return ""
        return value.replace(/\D/g, '')
    }

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {
            const digitsOnly = formatPhone(phone)
            let isValid = digitsOnly.length >= selectedCountry.nsnLength.min && digitsOnly.length <= selectedCountry.nsnLength.max
            if (!isMandatory && !phone) {
                isValid = true
            }

            if (isValid) {
                setError(false)
            }
            else {
                if (isInteracted) {
                    setError(true)
                }
            }

            return {
                isValid,
                value: {
                    countryCode: selectedCountry.code,
                    number: digitsOnly,
                    extension: formatPhone(extension),
                },
            }
        },
    }))

    const placeHolderForDigit = selectedCountry?.nsnLength?.min === selectedCountry?.nsnLength?.max ?
        `Enter ${selectedCountry?.nsnLength?.min}-digit number` :
        `Enter ${selectedCountry?.nsnLength?.min} to ${selectedCountry?.nsnLength?.max}-digit number`

    return (
        <div className="mb-5">
            <label className="block text-sm font-medium text-gray-700 mb-1">
                {title ? `${title}${isMandatory ? "*" : ""}` : `Phone Number${isMandatory ? "*" : ""}`}
            </label>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
                <select
                    className="border border-gray-300 rounded-md p-2 bg-white w-full col-span-1"
                    value={selectedCountry.code}
                    disabled={readOnly}
                    onChange={(e) => {
                        const selected = countryOptions.find(c => c.code === e.target.value)
                        setSelectedCountry(selected)
                        setPhone('')
                        setError(false)
                    }}
                >
                    {countryOptions.map((country) => (
                        <option key={country.label} value={country.code}>
                            {country.label} (+{country.code})

                        </option>
                    ))}
                </select>

                <div className="flex items-center border border-gray-300 rounded-md px-3 bg-white w-full col-span-2">
                    <span className="text-gray-700">+{selectedCountry.code}</span>
                    <input
                        type="text"
                        inputMode="numeric"
                        value={phone}
                        disabled={readOnly}
                        onChange={(e) => setPhone(formatPhone(e.target.value))}
                        maxLength={selectedCountry.nsnLength.max}
                        className="ml-2 flex-1 outline-none py-2"
                        placeholder={placeHolderForDigit}
                    />
                </div>

                <input
                    type="text"
                    inputMode="numeric"
                    value={extension}
                    onChange={(e) => setExtension(formatPhone(e.target.value))}
                    maxLength={selectedCountry.extensionLength.max}
                    disabled={readOnly}
                    placeholder={"Ext."}
                    className="w-full rounded-md border border-gray-300 px-3 bg-white col-span-1 py-2"
                />
            </div>

            {error && !readOnly && (
                <p className="mt-1 text-sm text-red-600">
                    Enter a valid phone number.
                </p>
            )}
        </div>
    )
})
